import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
export function TextareaInput(props) {
  const $ = _c(29);
  const submitError = !props.meta.dirtySinceLastSubmit ? props.meta.submitError : undefined;
  const errorMessage = props.meta.error || submitError;
  const hasError = !!errorMessage && (props.meta.touched || props.meta.submitFailed);
  const errorId = `${props.input.name}-error`;
  let t0;
  if ($[0] !== props.classNameContainer) {
    t0 = mergeClasses("relative", props.classNameContainer);
    $[0] = props.classNameContainer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.input;
  const t2 = props.hideLabel ? props.label : "";
  const t3 = props.rows || 3;
  const t4 = props.label;
  const t5 = hasError ? errorId : undefined;
  const t6 = hasError ? "true" : "false";
  const t7 = props.input.name;
  let t8;
  if ($[2] !== hasError || $[3] !== props.className) {
    t8 = mergeClasses("input h-auto", {
      "border-red-500 placeholder-red-500": hasError
    }, props.className);
    $[2] = hasError;
    $[3] = props.className;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== props.input || $[6] !== props.label || $[7] !== t2 || $[8] !== t3 || $[9] !== t5 || $[10] !== t6 || $[11] !== t8) {
    t9 = <textarea {...t1} placeholder={t2} rows={t3} aria-label={t4} aria-describedby={t5} aria-invalid={t6} id={t7} className={t8} data-clarity-mask="true" />;
    $[5] = props.input;
    $[6] = props.label;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = props.input.name;
  let t11;
  if ($[13] !== hasError || $[14] !== props.hideLabel) {
    t11 = mergeClasses("label", {
      hidden: props.hideLabel
    }, {
      "text-red-500": hasError
    });
    $[13] = hasError;
    $[14] = props.hideLabel;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== props.input.name || $[17] !== props.label || $[18] !== t11) {
    t12 = <label htmlFor={t10} className={t11}>{props.label}</label>;
    $[16] = props.input.name;
    $[17] = props.label;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== errorId || $[21] !== errorMessage || $[22] !== hasError) {
    t13 = hasError && <ErrorMessage error={errorMessage} id={errorId} />;
    $[20] = errorId;
    $[21] = errorMessage;
    $[22] = hasError;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t0 || $[25] !== t12 || $[26] !== t13 || $[27] !== t9) {
    t14 = <div className={t0}>{t9}{t12}{t13}</div>;
    $[24] = t0;
    $[25] = t12;
    $[26] = t13;
    $[27] = t9;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}